import type { AnnouncementCar } from '@autobid/ui/types/Car'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { auctionCarsQueryKey } from '@autobid/ui/composables/car/data/useAuctionCars'
import { getBarometerQueryKey } from '@autobid/ui/composables/car/data/useBarometerCar'
import {
  announcementCarQueryKey,
} from '@autobid/ui/composables/car/data/useCurrentCarAnnouncement'
import { searchCarsQueryKey } from '@autobid/ui/composables/car/data/useSearchCars'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'
import { singleAuctionQueryKey } from '@autobid/ui/composables/useAuction'
import { useQueryClient } from '@tanstack/vue-query'

export function useCurrentCarAnnouncementCarEnterHotbid() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()
  const { updateAnnouncementCarData } = useUpdateCar()

  const carEnterHotbid = () => {
    startListen({
      eventName: 'premium.CAR_ENTER_HOTBID',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId, carId, start } = event.context
        const queryKey = announcementCarQueryKey.byAuctionId(auctionId)
        const currentData = queryClient.getQueryData(
          queryKey,
          { stale: false },
        ) as AnnouncementCar | undefined

        if (!currentData)
          return

        if (currentData.id !== carId) {
          // invalid auction state - we have other car IN_AUCTION than the WS
          queryClient.invalidateQueries(getBarometerQueryKey({ type: 'item' }))
          queryClient.invalidateQueries(
            getBarometerQueryKey({ type: 'current' }),
          )
          queryClient.invalidateQueries(auctionCarsQueryKey.all())
          queryClient.invalidateQueries(announcementCarQueryKey.all())
          queryClient.invalidateQueries(searchCarsQueryKey.all())
          queryClient.invalidateQueries(singleAuctionQueryKey.all())
          return
        }

        updateAnnouncementCarData(auctionId, (item) => {
          if (!item) {
            return item
          }

          if (item.id !== carId) {
            return item
          }

          return {
            ...item,
            inActiveHotbidPhase: true,
            hotbidStartTime: new Date(start).toISOString(),
          }
        })
      },
    })
  }

  return { carEnterHotbid }
}
